<h4>
  Relatórios disponíveis
</h4>
<hr>
<button (click)="generateReport()" class="btn btn-sm btn-primary">Gerar relatório de Análise de contas</button>
<br>
<br>
<button (click)="goback()" class="btn btn-sm btn-default">Voltar</button>
<br>
<br>
<!-- <button (click)="generatePdfTest()" class="btn btn-sm btn-default">generate teste</button> -->